import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import BasicParagraphPSWorld from './PWSupportingComponents/BasicParagraphPSWorld';


const BannerModule = ({
  handlerSetComponents, components, id, reusableComponent, languages, activeLanguage,
}) => {
  const initialState = {
    type: 'BannerModule',
    title: '',
    hideUrl: true,
    text: {
      en: '',
      es: '',
      ca: '',
      pt: '',
    },
    url: '',
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    const { component } = components[index];

    const comp = {
      ...component,
      [name]: value,
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const inputHandlerByLanguage = (contentHtml, name, lang) => {
    const { component } = components[index];

    const comp = {
      ...component,
      [name]: {
        ...component[name],
        [lang.toLowerCase()]: contentHtml,
      },
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const handleInputBanner = (contentHtml, lang) => {
    if (index >= 0) {
      inputHandlerByLanguage(contentHtml, 'text', lang, 'banner');
    }
  };

  const toggleHandler = (e, bool) => {
    const { name } = e.target;
    const { component } = components[index];

    const comp = {
      ...component,
      [name]: bool,
    };
    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    if (component) {
      setState(component);
    } else {
      const componentObj = {
        id,
        component: state,
      };
      handlerSetComponents(componentObj, componentIndex);
    }
  }, [components]);

  return (
    <div className="w-full px-5 rounded-lg flex flex-row pt-4 pb-4">
      <div className="pl-9 w-full">
        <div className="bg-greyFilter w-full  p-4">
          <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2" htmlFor="title">
            Banner title
            <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" onChange={(e) => { inputHandler(e); }} name="title" type="text" value={(state && state.title) || ''} />
          </label>
        </div>
        <div className="bg-greyFilter w-full flex p-4">
          <label className="flex font-americaMonoRegular flex flex-col text-xs uppercase text-black pr-2 mr-2 w-3/4" htmlFor="title">
            Banner Url
            <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" onChange={(e) => { inputHandler(e); }} name="url" type="url" value={(state && state.url) || ''} />
          </label>
          <div className="text-xs uppercase pl-1 text-black font-americaMonoRegular flex flex-row items-center whitespace-pre pl-3">
            Hide Url
            <label className="switch mb-0 pb-0 h-6 ml-1">
              <input
                className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm"
                name="hideUrl"
                checked={!state.hideUrl}
                onChange={e => toggleHandler(e, !state.hideUrl)}
                type="checkbox"
                id="switch-button"
              />
              <div className="switch-slider btn-yn switch-round" />
            </label>
          </div>
        </div>
        <BasicParagraphPSWorld
          title="General description"
          handleInput={handleInputBanner}
          activeLanguage={activeLanguage}
          languages={languages}
          stateField={(state && state.text) || undefined}
        />
      </div>
    </div>
  );
};

BannerModule.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
  activeLanguage: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
};
BannerModule.defaultProps = {
  reusableComponent: null,
};

export default BannerModule;
